// src/store/authStore.js
import { create } from 'zustand'
import authService from '../services/authService'

const useAuthStore = create((set) => ({
    user: null,
    token: null,
    loading: false,
    error: null,

    register: async (data) => {
        set({ loading: true, error: null })
        try {
            await authService.register(data)
            set({ loading: false })
        } catch (error) {
            set({ error: error.message, loading: false })
            console.error('Registration failed', error)
        }
    },

    login: async (email, password) => {
        set({ loading: true, error: null })
        try {
            const response = await authService.login({ email, password })
            if (response.data.success) {
                const { access_token } = response.data.data
                const token = access_token.split(' ')[1] // Remove "Bearer " prefix

                localStorage.setItem('token', token)
                set({ token, loading: false })
                return true
            } else {
                set({ error: response.data.message, loading: false })
                console.error('Login failed', response.data.message)
                return false
            }
        } catch (error) {
            set({ error: error.message, loading: false })
            console.error('Login failed', error)
            return false
        }
    },

    logout: async () => {
        set({ loading: true, error: null })
        try {
            // await authService.logout()
            localStorage.removeItem('token')
            set({ user: null, token: null, loading: false })
        } catch (error) {
            set({ error: error.message, loading: false })
            console.error('Logout failed', error)
        }
    },

    loadUserFromLocalStorage: () => {
        set({ loading: true, error: null })
        const token = localStorage.getItem('token')
        if (token) {
            set({ token, loading: false })
        } else {
            set({ loading: false })
        }
    },
}))

export default useAuthStore
